/** Marketplace legal copy — keep in sync with /legal/marketplace/ page. */

import { siteBrandName } from '@/platform/legal/siteLegal';

export const MARKETPLACE_PURCHASE_TERMS_VERSION = '2026-06-16';
export const MARKETPLACE_SELLER_TERMS_VERSION = '2026-06-16';

export function marketplaceBrandName(): string {
  return siteBrandName();
}

export function marketplacePurchaseDisclosure(brand = marketplaceBrandName()) {
  return {
    sellerModel: `You are purchasing from an independent seller—not from ${brand}.`,
    verification: `${brand} verifies sellers before they can accept payments, but does not guarantee product quality.`,
    noReturns: `${brand} provides checkout technology only and does not handle returns, refunds, or product warranties.`,
    contactVendor: 'For order issues, contact the vendor using the support information on your order.',
    governance: `${brand} may investigate seller conduct and take action against vendors who violate our policies.`,
  };
}

export function marketplaceOrderDisclaimer(brand = marketplaceBrandName()) {
  return `This purchase was made directly with the vendor. ${brand} does not handle returns or refunds—contact the seller for order support.`;
}

export const vendorPolicyReminder =
  'You are solely responsible for product accuracy, shipping, returns, and refunds per the policies you publish. Violations may result in suspension or termination.';

/** @deprecated Use marketplacePurchaseDisclosure() for tenant-specific brand. */
export const marketplacePurchaseDisclosureLegacy = marketplacePurchaseDisclosure();

/** @deprecated Use marketplaceOrderDisclaimer() for tenant-specific brand. */
export const marketplaceOrderDisclaimerLegacy = marketplaceOrderDisclaimer();
